<form #form="ngForm" autocomplete="off">
  <div class="row align-items-end">
    <div class="col-sm">
      <div class="form-group">
        <label for="lastName" class="form-label">Last Name</label>
        <input
          #lastName="ngModel"
          id="lastName"
          type="text"
          class="form-control field"
          [(ngModel)]="searchRequest.lastName"
          name="lastName"
          obscure
        />
      </div>
    </div>
    <div class="col-sm">
      <div class="form-group">
        <label for="firstName" class="form-label">First Name</label>
        <input
          id="firstName"
          type="text"
          class="form-control field"
          [(ngModel)]="searchRequest.firstName"
          name="firstName"
          obscure
        />
      </div>
    </div>
    <div class="col-sm">
      <div class="form-group">
        <label for="middleName" class="form-label">Middle Name</label>
        <input
          id="middleName"
          type="text"
          class="form-control field"
          [(ngModel)]="searchRequest.middleName"
          name="middleName"
          obscure
        />
      </div>
    </div>
    <div class="col-sm">
      <div class="form-group" autocomplete="off">
        <label for="phoneNumber" class="form-label">Phone Number</label>
        <input
          id="phoneNumber"
          type="text"
          class="form-control"
          [(ngModel)]="searchRequest.phoneNumber"
          name="phoneNumber"
          numericOnly
          obscure
        />
      </div>
    </div>
  </div>
  <div class="row align-items-start">
    <div class="col-sm">
      <div class="form-group">
        <label for="ein" class="form-label">EIN</label>
        <input id="ein" type="text" class="form-control" [(ngModel)]="searchRequest.ein" name="ein" numericOnly />
      </div>
    </div>
    <div class="col-sm">
      <div class="form-group">
        <label for="dateOfBirth" class="form-label">Date of Birth</label>
        <cert-date-input
          name="dateOfBirth"
          [(model)]="dateOfBirth"
          [propertyName]="'dateOfBirth'"
          [useObscurity]="obscurityFeatureActive()"
        />
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group">
        <label for="email" class="form-label">Email</label>
        <input
          id="email"
          type="email"
          class="form-control email-field"
          [(ngModel)]="searchRequest.email"
          name="email"
          obscure
        />
      </div>
    </div>
    <div class="col-sm">
      <div class="form-group">
        <label for="ssn" class="form-label">Social Security</label>
        <input
          id="ssn"
          type="text"
          class="form-control"
          [(ngModel)]="searchRequest.ssn"
          name="ssn"
          numericOnly
          obscure
        />
      </div>
    </div>
    <div class="col-sm">
      <div class="form-group">
        <label for="educatorStakeholderId" class="form-label">Educator Stakeholder Id</label>
        <input
          id="educatorStakeholderId"
          type="text"
          class="form-control"
          [(ngModel)]="searchRequest.educatorStakeholderId"
          name="educatorStakeholderId"
          numericOnly
        />
      </div>
    </div>
  </div>
</form>

@if (searching()) {
  <ngx-skeleton-loader count="5" />
}

<!--results-->
@if (!searching()) {
  <div class="table-container d-flex flex-column">
    @if (staff() && staff()!.length !== 0) {
      <div
        infinite-scroll
        [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()"
        [scrollWindow]="false"
        [infiniteScrollDistance]="2"
        class="table-responsive"
      >
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Social Security</th>
              <th scope="col">EIN</th>
              <th scope="col">Educator Stakeholder Id</th>
              <th scope="col">Date of Birth</th>
              <th scope="col">Phone Number</th>
              <th scope="col">Email</th>
            </tr>
          </thead>
          <tbody>
            @for (person of staff(); track person.personId) {
              <tr class="educator-row" (click)="goToStaffDetails(person.personId)">
                <td obscure>
                  {{ person.educatorName }}
                  <ng-template #alternateNamesPopoverContent>
                    @for (alternateName of person.alternateNames; track $index) {
                      <p class="popover-spacing">{{ alternateName }}</p>
                    }
                  </ng-template>
                  @if (person.alternateNames && person.alternateNames.length) {
                    <i
                      class="bi bi-info-circle pointer"
                      [ngbPopover]="alternateNamesPopoverContent"
                      (click)="stopPropagation($event)"
                      popoverTitle="Alternate Names"
                      certTooltip="Alternate Names"
                    >
                    </i>
                  }
                </td>
                <td obscure>{{ person.ssn | SSN: true }}</td>
                <td>{{ person.ein }}</td>
                <td>{{ person.educatorStakeholderId | guidFormat }}</td>
                <td obscure>{{ person.dateOfBirth | date: 'MM/dd/yyyy' }}</td>
                <td obscure>
                  {{ person.lastActivePhoneNumber | phoneNumber }}
                  <ng-template #phoneNumbersPopoverContent>
                    @for (phoneNumber of person.alternatePhoneNumbers; track $index) {
                      <p class="popover-spacing">{{ phoneNumber | phoneNumber }}</p>
                    }
                  </ng-template>
                  @if (person.phoneNumbers && person.alternatePhoneNumbers.length) {
                    <i
                      class="bi bi-info-circle pointer"
                      [ngbPopover]="phoneNumbersPopoverContent"
                      (click)="stopPropagation($event)"
                      popoverTitle="Phone Numbers"
                    >
                    </i>
                  }
                </td>
                <td obscure>
                  {{ person.lastActiveEmail }}
                  <ng-template #emailsPopoverContent>
                    @for (email of person.alternateEmails; track $index) {
                      <p class="popover-spacing">{{ email }}</p>
                    }
                  </ng-template>
                  @if (person.emails && person.alternateEmails.length) {
                    <i
                      class="bi bi-info-circle pointer"
                      [ngbPopover]="emailsPopoverContent"
                      (click)="stopPropagation($event)"
                      popoverTitle="Emails"
                    >
                    </i>
                  }
                </td>
              </tr>
            }
            <tr>
              <td colspan="7" class="text-center">
                @if (!endOfResults()) {
                  <p class="text-secondary my-auto">Scroll down for more results</p>
                } @else {
                  <p class="text-secondary my-auto">No more results exist</p>
                }
              </td>
            </tr>
          </tbody>
        </table>

        @if (scrollSearching()) {
          <ngx-skeleton-loader count="5" />
        }
      </div>
    }
    @if (staff() && staff()!.length === 0) {
      <div class="my-2 d-flex justify-content-center">
        <h5>No Results</h5>
      </div>
    }
  </div>
}
